import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "js-main-content" }
const _hoisted_2 = {
  ref: "commentsView",
  class: "gfu-comments-view",
  "data-qa": "project-comments-box:Comments"
}
const _hoisted_3 = { class: "gfu-comments-view__main" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-comments-view__title gfu-content-head"
}
const _hoisted_5 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}
const _hoisted_6 = {
  class: "gfu-box__content",
  "data-qa": "blocked-from-commenting-section"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "gfu-hd gfu-hd--h3" }
const _hoisted_9 = {
  "format-key": "0",
  class: "_fw-b"
}
const _hoisted_10 = { class: "gfu-bt gfu-bt--caption" }
const _hoisted_11 = {
  "format-key": "0",
  class: "gfu-comment-badge"
}
const _hoisted_12 = { "format-key": "1" }
const _hoisted_13 = { class: "gfu-bt gfu-bt--caption" }
const _hoisted_14 = {
  key: 0,
  class: "gfu-comments-view__side"
}
const _hoisted_15 = { class: "gfu-comments-view__title gfu-content-head" }
const _hoisted_16 = { class: "gfu-hd gfu-hd--h1" }
const _hoisted_17 = { class: "_mt-3 _flexwrap _gap-1" }
const _hoisted_18 = { class: "gfu-comment-streams__tags _flexwrap _gap-1" }
const _hoisted_19 = {
  key: 0,
  class: "gfu-comment-streams__paragraph"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_comment_filter_item = _resolveComponent("comment-filter-item")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_localize = _resolveComponent("localize")
  const _component_comment_restriction = _resolveComponent("comment-restriction")
  const _component_project_comment_field = _resolveComponent("project-comment-field")
  const _component_project_comment_login = _resolveComponent("project-comment-login")
  const _component_multi_selector_field = _resolveComponent("multi-selector-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_project_comment_thread = _resolveComponent("project-comment-thread")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_project_comments_streams = _resolveComponent("project-comments-streams")
  const _component_box = _resolveComponent("box")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_project_comments_mobile_menu = _resolveComponent("project-comments-mobile-menu")
  const _component_report_project_comment_modal = _resolveComponent("report-project-comment-modal")
  const _component_report_and_hide_project_comment_modal = _resolveComponent("report-and-hide-project-comment-modal")
  const _component_set_nickname_modal = _resolveComponent("set-nickname-modal")

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($options.isHeadVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.Comments.PageHeader), 1 /* TEXT */),
              ($options.selectedFilterModel)
                ? (_openBlock(), _createBlock(_component_comment_filter_item, {
                    key: $options.selectedFilterModel.name,
                    name: $options.selectedFilterModel.name,
                    "is-selected": $options.selectedFilterModel.isSelected,
                    "is-thin": false,
                    class: _normalizeClass([$options.selectedFilterModel.class, '_mx-1']),
                    onClick: _cache[0] || (_cache[0] = $event => ($options.selectedFilterModel.fn($data.filter.value)))
                  }, null, 8 /* PROPS */, ["name", "is-selected", "class"]))
                : ($options.isMobile)
                  ? (_openBlock(), _createBlock(_component_icon_base_button, {
                      key: 1,
                      class: "_mx-1 _fw-b",
                      icon: "search",
                      weight: "thin",
                      lowercase: true,
                      size: "micro",
                      shape: "soft",
                      onClick: $options.onDrawerOpen
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.Comments.SearchTagButton), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]))
                  : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent($options.wrapperComponent.component), _normalizeProps(_guardReactiveProps($options.wrapperComponent.props)), {
          default: _withCtx(() => [
            ($options.isMainFieldVisible)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.isUserBanned)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.Resources.Comments.UserBannedHeader), 1 /* TEXT */),
                          _createVNode(_component_localize, {
                            resource: _ctx.Resources.Comments.UserBannedDescription
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Resources.Comments.CommunityGuidelinesLink), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["resource"])
                        ]))
                      : ($options.isCommentRestrictionsVisible)
                        ? (_openBlock(), _createBlock(_component_comment_restriction, { key: 1 }))
                        : ($options.isUserAuthenticated)
                          ? (_openBlock(), _createBlock(_component_project_comment_field, {
                              key: 2,
                              ref: "addComment",
                              "extra-tag": $data.filter.tag,
                              onSubmit: $options.addComment,
                              onNicknameRequired: $options.onNicknameRequired,
                              "data-qa": "project-comments-field:AddNew"
                            }, null, 8 /* PROPS */, ["extra-tag", "onSubmit", "onNicknameRequired"]))
                          : (_openBlock(), _createBlock(_component_project_comment_login, { key: 3 }))
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gfu-box-divider gfu-box-divider--content" }, null, -1 /* CACHED */))
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              ref: "commentsSection",
              class: _normalizeClass([
                            'gfu-comments-view-content',
                            {
                                'gfu-comments-view-content--compact': $options.isLayoutCompact,
                                'gfu-box__content': !$options.isLayoutModal,
                            },
                        ])
            }, [
              ($data.comments.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    ($options.isFiltersFieldVisible)
                      ? (_openBlock(), _createBlock(_component_multi_selector_field, {
                          key: 0,
                          modelValue: $data.filter.sortType,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.filter.sortType) = $event)),
                          class: "gfu-comment-filters",
                          name: "filter.sortType",
                          "show-label": false,
                          options: $options.sortTypes,
                          "data-qa": "project-comments-multi-selector"
                        }, null, 8 /* PROPS */, ["modelValue", "options"]))
                      : _createCommentVNode("v-if", true),
                    ($options.isNewMessageButtonVisible)
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 1,
                          theme: "lightAlt",
                          shape: "hard",
                          display: "block",
                          shadow: "tight",
                          class: "_mt-6 _mb-6",
                          onClick: $options.downloadNewMessages,
                          "data-qa": "project-comments-button:LoadMore"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, [
                              (_openBlock(), _createBlock(_component_localize, {
                                key: `newMessagesCount:${$data.newMessagesCount}`,
                                resource: _ctx.Resources.Comments.LoadNewMessagesButton
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_11, _toDisplayString($data.newMessagesCount), 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_12, _toDisplayString($options.newMessagesCountLabel), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["resource"]))
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.comments, (thread) => {
                      return (_openBlock(), _createBlock(_component_project_comment_thread, {
                        key: `commentID:${thread.commentID}`,
                        ref_for: true,
                        ref: "commentThreads",
                        class: "_mb-3",
                        "has-pin-comment-action": $options.hasPinCommentAction,
                        "has-report-and-hide-action": $options.hasReportAndHideAction,
                        "allow-creator-hiding-comments": $props.allowCreatorHidingComments,
                        thread: thread,
                        "can-comment": $props.canComment,
                        onDelete: $options.onDelete,
                        onPin: $options.onPin,
                        onManage: $options.onManage,
                        onReport: $options.onReportComment,
                        onLike: $options.onLike,
                        onNicknameRequired: $options.onNicknameRequired,
                        onReplySubmit: $options.onReplyComment,
                        onEditSubmit: $options.onUpdateComment,
                        onTagSelected: $options.onTagSelected,
                        onReportAndHide: $options.onReportAndHide,
                        onLoadMoreChildren: $options.loadMoreChildren,
                        onGoToUserAdmin: $options.onGoToUserAdmin
                      }, null, 8 /* PROPS */, ["has-pin-comment-action", "has-report-and-hide-action", "allow-creator-hiding-comments", "thread", "can-comment", "onDelete", "onPin", "onManage", "onReport", "onLike", "onNicknameRequired", "onReplySubmit", "onEditSubmit", "onTagSelected", "onReportAndHide", "onLoadMoreChildren", "onGoToUserAdmin"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($options.isLoadMoreCommentsVisible)
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 2,
                          theme: "lightAlt",
                          shape: "hard",
                          display: "block",
                          shadow: "tight",
                          class: "_mt-3",
                          onClick: $options.loadMoreComments,
                          "data-qa": "project-comments-button:LoadMore"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_13, [
                              _createTextVNode(_toDisplayString(_ctx.Resources.Comments.LoadMoreButton) + " ", 1 /* TEXT */),
                              _createVNode(_component_base_icon, {
                                name: "chevron-down",
                                class: "_ml-1 _tc--accent"
                              })
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : ($data.isInitialized)
                  ? (_openBlock(), _createBlock(_component_empty_state, {
                      key: 1,
                      title: _ctx.Resources.Comments.EmptyStateHeader,
                      description: _ctx.Resources.Comments.EmptyStateParagraph
                    }, null, 8 /* PROPS */, ["title", "description"]))
                  : _createCommentVNode("v-if", true),
              _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */))
      ]),
      ($options.isSideVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.Resources.Comments.TagsSectionHeader), 1 /* TEXT */)
            ]),
            _createVNode(_component_box, {
              class: "gfu-comment-streams__box",
              "data-qa": "project-comments-box:Streams"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_project_comments_streams, {
                  "comment-thread-id": $options.commentThreadId,
                  "current-tag": $data.filter.tag,
                  onTagDeselected: $options.onTagDeselected,
                  onTagSelected: $options.onTagSelected,
                  onSearchTags: $options.onSearchTags
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filters, (filter) => {
                        return (_openBlock(), _createBlock(_component_comment_filter_item, {
                          key: filter.name,
                          name: filter.name,
                          "is-selected": filter.isSelected,
                          class: _normalizeClass(filter.class),
                          onClick: $event => (filter.fn(filter.value)),
                          "data-qa": `comments-streams-filter:${filter.qa}`
                        }, null, 8 /* PROPS */, ["name", "is-selected", "class", "onClick", "data-qa"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                        return (_openBlock(), _createBlock(_component_comment_filter_item, {
                          key: tag.name,
                          name: tag.name,
                          "is-selected": tag.isSelected,
                          class: _normalizeClass(tag.class),
                          onClick: $event => (tag.fn(tag.value)),
                          "data-qa": `comments-streams:${tag.value}`
                        }, null, 8 /* PROPS */, ["name", "is-selected", "class", "onClick", "data-qa"]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (!$options.hasTags)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.Resources.Comments.TagsEmptyStateHeader), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["comment-thread-id", "current-tag", "onTagDeselected", "onTagSelected", "onSearchTags"])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    ($props.showRecommendations && $data.isInitialized)
      ? (_openBlock(), _createBlock(_component_project_recommendations, {
          key: 0,
          quantity: 12,
          title: _ctx.Resources.Comments.ProjectRecommendationsTitle,
          "exclude-project-ids": [_ctx.projectContext.projectID],
          source: "project-comments",
          class: "_mt-6"
        }, null, 8 /* PROPS */, ["title", "exclude-project-ids"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_project_comments_mobile_menu, {
      "comment-thread-id": $options.commentThreadId,
      "current-tag": $data.filter.tag,
      "is-drawer-open": $data.isDrawerOpen,
      onTagDeselected: $options.onTagDeselected,
      onTagSelected: $options.onTagSelected,
      onSearchTags: $options.onSearchTags,
      onDrawerClose: $options.onDrawerClose
    }, null, 8 /* PROPS */, ["comment-thread-id", "current-tag", "is-drawer-open", "onTagDeselected", "onTagSelected", "onSearchTags", "onDrawerClose"]),
    _createVNode(_component_report_project_comment_modal, {
      ref: "reportProjectCommentModal",
      onCommentReportSubmitted: $options.onCommentReportSubmitted
    }, null, 8 /* PROPS */, ["onCommentReportSubmitted"]),
    ($data.isReportAndHideCommentModalOpen)
      ? (_openBlock(), _createBlock(_component_report_and_hide_project_comment_modal, _mergeProps({ key: 1 }, $data.model, {
          onCommentHidden: $options.onCommentHidden,
          onModalClose: $options.onReportAndHideCommentModalClose
        }), null, 16 /* FULL_PROPS */, ["onCommentHidden", "onModalClose"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_set_nickname_modal, {
      ref: "setNicknameModal",
      onNicknameUpdated: $options.onNicknameUpdated
    }, null, 8 /* PROPS */, ["onNicknameUpdated"])
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $options.isVisible]
  ])
}